import { cva } from 'class-variance-authority';

export const navItemStyles = cva(
  'px-2 py-1.5 text-sm font-semibold text-neutrals-N800 hover:bg-neutrals-N200 rounded-md transition-colors hover:cursor-pointer',
);
